(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bg-color-spread-test"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const bgSection = document.querySelector(".bg-section");
  const content = document.querySelector(".content");
  
  if (!bgSection || !content) {
    console.error("必要な要素が見つかりません。クラス名を確認してください。");
    return;
  }

  const options = {
    root: null,
    threshold: 0.5,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log("コンテンツがビューポートに入ったので、背景色を変更します");
        bgSection.style.backgroundColor = "#FFD700";
      } else {
        console.log("コンテンツがビューポート外に出たので、背景色を戻します");
        bgSection.style.backgroundColor = "#f0f0f0";
      }
    });
  }, options);

  observer.observe(content);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-list"] && !Shopify.designMode) return;
  try {
    
  AOS.init();

// 動きのきっかけの起点となるアニメーションの名前を定義
function moveAnimation() {
  //読み込まれたらすぐにランダムに出現
  var randomElm = $(".randomBox"); //親要素取得
  var randomElmChild = $(randomElm).children(); //親の子要素を取得
  if (!$(randomElm).hasClass("play")) {
    //親要素にクラス名playが付いてなければ処理をおこなう
    randomAnime();
  }

  function randomAnime() {
    $(randomElm).addClass("play"); //親要素にplayクラスを付与
    var rnd = Math.floor(Math.random() * randomElmChild.length); //配列数からランダム数値を取得
    var moveData = "fadeUp"; //アニメーション名＝CSSのクラス名を指定
    $(randomElmChild[rnd]).addClass(moveData); //アニメーションのクラスを追加
    randomElmChild.splice(rnd, 1); //アニメーション追加となった要素を配列から削除
    if (randomElmChild.length == 0) {
      //配列の残りがあるか確認
      $(randomElm).removeClass("play"); //なくなった場合は親要素のplayクラスを削除
    } else {
      setTimeout(function () {
        randomAnime();
      }, 500); //0.5秒間隔でアニメーションをスタートさせる。※ランダムのスピード調整はこの数字を変更させる
    }
  }

  //スクロールしたらランダムに出現
  var randomElm2 = $(".randomScroll"); //親要素取得
  var randomElm2Child = $(randomElm2).children(); //親の子要素を取得
  randomScrollAnime();
  function randomScrollAnime() {
    var elemPos = $(".randomScroll").offset().top - 50; //要素より、50px上まで来たら
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      if (randomElm2Child.length > 0) {
        //配列数以上であれば処理をおこなう
        var rnd = Math.floor(Math.random() * randomElm2Child.length); //配列数から表示する数値をランダムで取得
        var moveData = "fadeUp"; //アニメーション名＝CSSのクラス名を指定
        if (animeFlag) {
          //スクロールする度に動作するのでアニメーションが終わるまで処理をさせないようにする
          animeFlag = false; //アニメーション処理が終わるまで一時的にfalseにする
          $(randomElm2Child[rnd]).addClass(moveData); //アニメーションのクラスを追加
          setTimeout(function () {
            animeFlag = true; //次の処理をおこなうためにtrueに変更
            randomScrollAnime(); //自身の処理を繰り返す
          }, 500); //0.5秒間隔で。※ランダムのスピード調整はこの数字を変更させる
          randomElm2Child.splice(rnd, 1); //アニメーション追加となった要素を配列から削除
        }
      }
    } else {
      animeFlag = true;
    }
  }
}

var animeFlag = true; //スクロールする度に動作するのでアニメーションが終わるまで処理をさせないようにするための定義

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  moveAnimation(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on("load", function () {
  moveAnimation(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面が読み込まれたらすぐに動かしたい場合の記述

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profileSpace"] && !Shopify.designMode) return;
  try {
    
// 動きのきっかけの起点となるアニメーションの名前を定義
function moveAnimation() {
  //読み込まれたらすぐにランダムに出現
  var randomElm = $(".randomBox"); //親要素取得
  var randomElmChild = $(randomElm).children(); //親の子要素を取得
  if (!$(randomElm).hasClass("play")) {
    //親要素にクラス名playが付いてなければ処理をおこなう
    randomAnime();
  }

  function randomAnime() {
    $(randomElm).addClass("play"); //親要素にplayクラスを付与
    var rnd = Math.floor(Math.random() * randomElmChild.length); //配列数からランダム数値を取得
    var moveData = "fadeUp"; //アニメーション名＝CSSのクラス名を指定
    $(randomElmChild[rnd]).addClass(moveData); //アニメーションのクラスを追加
    randomElmChild.splice(rnd, 1); //アニメーション追加となった要素を配列から削除
    if (randomElmChild.length == 0) {
      //配列の残りがあるか確認
      $(randomElm).removeClass("play"); //なくなった場合は親要素のplayクラスを削除
    } else {
      setTimeout(function () {
        randomAnime();
      }, 500); //0.5秒間隔でアニメーションをスタートさせる。※ランダムのスピード調整はこの数字を変更させる
    }
  }

  //スクロールしたらランダムに出現
  var randomElm2 = $(".randomScroll"); //親要素取得
  var randomElm2Child = $(randomElm2).children(); //親の子要素を取得
  randomScrollAnime();
  function randomScrollAnime() {
    var elemPos = $(".randomScroll").offset().top - 50; //要素より、50px上まで来たら
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      if (randomElm2Child.length > 0) {
        //配列数以上であれば処理をおこなう
        var rnd = Math.floor(Math.random() * randomElm2Child.length); //配列数から表示する数値をランダムで取得
        var moveData = "fadeUp"; //アニメーション名＝CSSのクラス名を指定
        if (animeFlag) {
          //スクロールする度に動作するのでアニメーションが終わるまで処理をさせないようにする
          animeFlag = false; //アニメーション処理が終わるまで一時的にfalseにする
          $(randomElm2Child[rnd]).addClass(moveData); //アニメーションのクラスを追加
          setTimeout(function () {
            animeFlag = true; //次の処理をおこなうためにtrueに変更
            randomScrollAnime(); //自身の処理を繰り返す
          }, 500); //0.5秒間隔で。※ランダムのスピード調整はこの数字を変更させる
          randomElm2Child.splice(rnd, 1); //アニメーション追加となった要素を配列から削除
        }
      }
    } else {
      animeFlag = true;
    }
  }
}

var animeFlag = true; //スクロールする度に動作するのでアニメーションが終わるまで処理をさせないようにするための定義

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  moveAnimation(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on("load", function () {
  moveAnimation(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面が読み込まれたらすぐに動かしたい場合の記述


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topBox-sma"] && !Shopify.designMode) return;
  try {
    
　'use strict';
　jQuery(function($){
　　$('.topBox-sma').vegas({
　　　slides:[
　　　　{src:'https://cdn.shopify.com/s/files/1/0599/5695/3184/files/20.png?v=1752669975'}
　],
  overlay: true,  
　transition: 'blur',
　transitionDuration: 3000,
　delay: 3500,
　cover:true,
　animation: 'random',
　animationDuration: 3000,
　timer: true,
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topBox"] && !Shopify.designMode) return;
  try {
    
  // スクロール時に実行する関数
  function handleScroll() {
    const logoImg = document.getElementById('logoImg');
    const threshold = 100; // ロゴが消え始めるスクロール量（ピクセル）

    if (window.scrollY > threshold) {
      logoImg.classList.add('fade-out');
    } else {
      logoImg.classList.remove('fade-out');
    }
  }

  // スクロールイベントを監視する
  window.addEventListener('scroll', handleScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbox-shita2"] && !Shopify.designMode) return;
  try {
    
(function () {

  const container = document.querySelector(".story-container");
  if (!container) return;

  const track = container.querySelector(".story-track");
  const slides = container.querySelectorAll(".story-slide");
  const bars = container.querySelectorAll(".progress-bar span");
  const nextBtn = container.querySelector(".story-arrow.next");
  const prevBtn = container.querySelector(".story-arrow.prev");

  let current = 0;
  const duration = 5000;
  let timer;
  let started = false; // ← 一度だけ発火

  function updateSlide(index) {
    track.style.transform = `translateX(-${index * 100}%)`;

    bars.forEach((bar, i) => {
      bar.style.transition = "none";
      bar.style.width = i < index ? "100%" : "0%";
    });

    requestAnimationFrame(() => {
      bars[index].style.transition = `width ${duration}ms linear`;
      bars[index].style.width = "100%";
    });
  }

  function nextSlide() {
    current = (current + 1) % slides.length;
    updateSlide(current);
  }

  function prevSlide() {
    current = (current - 1 + slides.length) % slides.length;
    updateSlide(current);
  }

  function startTimer() {
    timer = setInterval(nextSlide, duration);
  }

  function resetTimer() {
    clearInterval(timer);
    startTimer();
  }

  nextBtn.addEventListener("click", () => {
    nextSlide();
    resetTimer();
  });

  prevBtn.addEventListener("click", () => {
    prevSlide();
    resetTimer();
  });

  // 👇 ここが追加部分
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !started) {
        started = true;
        updateSlide(current);
        startTimer();
      }
    });
  }, {
    root: null,
    threshold: 0.3 // 30%見えたら発火
  });

  observer.observe(container);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-modaal"] && !Shopify.designMode) return;
  try {
    

  //Swiper設定
const mySwiper = new Swiper ('.swiper', {
slidesPerView: 1,
  speed: 1000,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
  },
loop:true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    641: {
      slidesPerView: 3,
    }
  }
   
});

function youtube_modal(trigger) {
  $(trigger).modaal({
    type: "video",
  });
}

youtube_modal(".video-open");

// 動きのきっかけの起点となるアニメーションの名前を定義
function moveAnimation() {
  //読み込まれたらすぐにランダムに出現
  var randomElm = $(".randomBox"); //親要素取得
  var randomElmChild = $(randomElm).children(); //親の子要素を取得
  if (!$(randomElm).hasClass("play")) {
    //親要素にクラス名playが付いてなければ処理をおこなう
    randomAnime();
  }

  function randomAnime() {
    $(randomElm).addClass("play"); //親要素にplayクラスを付与
    var rnd = Math.floor(Math.random() * randomElmChild.length); //配列数からランダム数値を取得
    var moveData = "fadeUp"; //アニメーション名＝CSSのクラス名を指定
    $(randomElmChild[rnd]).addClass(moveData); //アニメーションのクラスを追加
    randomElmChild.splice(rnd, 1); //アニメーション追加となった要素を配列から削除
    if (randomElmChild.length == 0) {
      //配列の残りがあるか確認
      $(randomElm).removeClass("play"); //なくなった場合は親要素のplayクラスを削除
    } else {
      setTimeout(function () {
        randomAnime();
      }, 500); //0.5秒間隔でアニメーションをスタートさせる。※ランダムのスピード調整はこの数字を変更させる
    }
  }

  //スクロールしたらランダムに出現
  var randomElm2 = $(".randomScroll"); //親要素取得
  var randomElm2Child = $(randomElm2).children(); //親の子要素を取得
  randomScrollAnime();
  function randomScrollAnime() {
    var elemPos = $(".randomScroll").offset().top - 50; //要素より、50px上まで来たら
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      if (randomElm2Child.length > 0) {
        //配列数以上であれば処理をおこなう
        var rnd = Math.floor(Math.random() * randomElm2Child.length); //配列数から表示する数値をランダムで取得
        var moveData = "fadeUp"; //アニメーション名＝CSSのクラス名を指定
        if (animeFlag) {
          //スクロールする度に動作するのでアニメーションが終わるまで処理をさせないようにする
          animeFlag = false; //アニメーション処理が終わるまで一時的にfalseにする
          $(randomElm2Child[rnd]).addClass(moveData); //アニメーションのクラスを追加
          setTimeout(function () {
            animeFlag = true; //次の処理をおこなうためにtrueに変更
            randomScrollAnime(); //自身の処理を繰り返す
          }, 500); //0.5秒間隔で。※ランダムのスピード調整はこの数字を変更させる
          randomElm2Child.splice(rnd, 1); //アニメーション追加となった要素を配列から削除
        }
      }
    } else {
      animeFlag = true;
    }
  }
}

var animeFlag = true; //スクロールする度に動作するのでアニメーションが終わるまで処理をさせないようにするための定義

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  moveAnimation(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on("load", function () {
  moveAnimation(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面が読み込まれたらすぐに動かしたい場合の記述
  

  } catch(e) { console.error(e); }
})();
})();
